
import React, { useEffect, useState } from "react";
import "../CSS/StudentDetailsModalAgent.css";

const API_URL =
  "https://advenwarecareerlink.com/acl/Agent/Student_details.php";

const StudentDetailsModal = ({ student, onClose }) => {

  const [studentDetails, setStudentDetails] = useState(null);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState("");


  useEffect(() => {

    const fetchStudentDetails = async () => {

      if (!student) {
        return;
      }

      try {

        setLoading(true);
        setError("");
        setStudentDetails(null);


        /*
          The ID card number is the value used
          to fetch the student's account.
        */

        const idNumber =
          student.idNumber ||
          student.id_number ||
          student.systemCode ||
          student.user_ID ||
          student.id ||
          "";


        if (!idNumber) {

          setError(
            "Student ID number is not available."
          );

          setLoading(false);

          return;
        }


        console.log(
          "Fetching student details using ID:",
          idNumber
        );


        const response = await fetch(
          API_URL,
          {
            method: "POST",

            headers: {
              "Content-Type":
                "application/json",

              Accept:
                "application/json",
            },

            body: JSON.stringify({
              id_num: idNumber,
            }),
          }
        );


        if (!response.ok) {

          throw new Error(
            "Failed to fetch student details."
          );

        }


        const data =
          await response.json();


        console.log(
          "Student details response:",
          data
        );


        /*
          PHP returns an array.

          Example:

          [
            {
              student_name: "...",
              user_ID: "...",
              ...
            }
          ]
        */

        if (
          !Array.isArray(data) ||
          data.length === 0
        ) {

          setError(
            "This student has not created an account yet."
          );

          setStudentDetails(null);

          return;
        }


        setStudentDetails(data[0]);

      } catch (err) {

        console.error(
          "Fetch student details error:",
          err
        );

        setError(
          "Unable to fetch the student's account details."
        );

      } finally {

        setLoading(false);

      }

    };


    fetchStudentDetails();

  }, [student]);


  if (!student) {
    return null;
  }


  /*
    CV returned directly from PHP
  */

  const cvUrl =
    studentDetails?.cv ||
    "";


  return (

    <div className="student-details-overlay">

      <div className="student-details-modal">


        {/* HEADER */}

        <div className="student-details-header">

          <div>

            <div className="student-details-label">
              STUDENT PROFILE
            </div>


            <h2>
              Student details
            </h2>


            <p>
              View the student's registration information.
            </p>

          </div>


          <button
            className="student-details-close"
            onClick={onClose}
            type="button"
            aria-label="Close"
          >
            ×
          </button>

        </div>


        {/* LOADING */}

        {loading && (

          <div className="student-details-content">

            <div className="student-detail-item student-detail-full">

              <span className="student-detail-label">
                Student account
              </span>

              <span className="student-detail-value">
                Loading student details...
              </span>

            </div>

          </div>

        )}


        {/* ERROR */}

        {!loading && error && (

          <div className="student-details-content">

            <div className="student-detail-item student-detail-full">

              <span className="student-detail-label">
                Account status
              </span>

              <span className="student-detail-value">
                {error}
              </span>

            </div>

          </div>

        )}


        {/* STUDENT DETAILS */}

        {!loading &&
          !error &&
          studentDetails && (

          <div className="student-details-content">


            {/* NAME */}

            <div className="student-detail-item student-detail-full">

              <span className="student-detail-label">
                Student's name
              </span>

              <span className="student-detail-value">

                {studentDetails.student_name ||
                  "Not provided"}

              </span>

            </div>


            {/* ID NUMBER */}

            <div className="student-detail-item">

              <span className="student-detail-label">
                ID number
              </span>

              <span className="student-detail-value">

                {studentDetails.ID ||
                  "Not provided"}

              </span>

            </div>


            {/* PHONE */}

            <div className="student-detail-item">

              <span className="student-detail-label">
                Phone number
              </span>

              <span className="student-detail-value">

                {studentDetails.phone_number ||
                  "Not provided"}

              </span>

            </div>


            {/* COUNTY */}

            <div className="student-detail-item">

              <span className="student-detail-label">
                County
              </span>

              <span className="student-detail-value">

                {studentDetails.county ||
                  "Not provided"}

              </span>

            </div>


            {/* COURSE */}

            <div className="student-detail-item">

              <span className="student-detail-label">
                Course
              </span>

              <span className="student-detail-value">

                {studentDetails.course ||
                  "Not provided"}

              </span>

            </div>


            {/* INSTITUTE */}

            <div className="student-detail-item student-detail-full">

              <span className="student-detail-label">
                Institute
              </span>

              <span className="student-detail-value">

                {studentDetails.institute ||
                  "Not provided"}

              </span>

            </div>


            {/* CV */}

            <div className="student-detail-item student-detail-full">

              <span className="student-detail-label">
                Student's CV
              </span>


              <div className="student-cv-container">

                {cvUrl ? (

                  <a
                    href= {`https://advenwarecareerlink.com/acl/My_account/${cvUrl}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="student-cv-button"
                  >
                    View CV
                  </a>

                ) : (

                  <span className="student-no-cv">
                    CV not available
                  </span>

                )}

              </div>

            </div>


          </div>

        )}


        {/* FOOTER */}

        <div className="student-details-footer">

          <button
            type="button"
            className="student-details-done-button"
            onClick={onClose}
          >
            Close
          </button>

        </div>


      </div>

    </div>

  );

};


export default StudentDetailsModal;

